import { Row, Radio as RadioAntd, Space } from "antd";
import { Fragment, h } from "preact";
import { useMemo } from "preact/hooks";
import { memo } from "react";
import { useController, UseControllerProps } from "react-hook-form";
import { compareRender } from "../../../functions/form";
import { Text } from "../../text";
import { StyledRadioButton, StyledRadioGroup } from "./styled";
import { Required, RowComponent } from "../../../style/styled";

interface IProperties {
  options: any[];
  valueKey?: string;
  labelKey?: string;
}

interface IItem extends UseControllerProps {
  ref: string;
  id: string;
  format?: string;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  properties: IProperties;
}

interface IRadio {
  control?: any;
  item: IItem;
  handleChange?: any;
}

const Radio = ({ control, item, handleChange }: IRadio) => {
  const { ref, rules, name, defaultValue, label, disabled, properties } = item;
  const { options, valueKey, labelKey } = properties;
  const { field, fieldState } = useController({
    control,
    name,
    rules,
    defaultValue,
  });
  const { error } = fieldState;
  const { value } = field;

  const opt = useMemo(() => {
    return options.map((e, i) => {
      const val = valueKey ? e[valueKey] : e;
      const lab = labelKey ? e[labelKey] : e;
      return (
        <StyledRadioButton key={i} value={val}>
          {lab}
        </StyledRadioButton>
      );
    });
  }, []);

  return (
    <>
      <RowComponent>
        {label &&
          ((<Text size={"XS"} text={label} bold={true} />) as React.ReactNode)}
        {rules && rules.required && <Required>*</Required>}
      </RowComponent>
      <StyledRadioGroup
        size="large"
        id={ref}
        value={value}
        disabled={disabled}
        onChange={(e) => handleChange(e, item)}
      >
        <Space direction="vertical">{opt}</Space>
      </StyledRadioGroup>
      <Row>
        {error &&
          ((
            <Text size={"XS"} text={error.message} color="red" bold />
          ) as React.ReactNode)}
      </Row>
    </>
  );
};

export const MemoizedRadio = memo(Radio, compareRender);
